import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import terminology from 'javascripts/terminology';

export class ReleaseName extends Field {
  static subqueriesForModel() {
    return { release: ['name'] };
  }

  get title() {
    return `${terminology('Release')} name`;
  }

  exampleContents(): FieldContentsData {
    return { text: 'Progress Dashboard v1' };
  }

  contentsForRecord(record): FieldContentsData {
    return { text: record.release?.name };
  }
}
